// Setup Vue
import { createApp } from 'vue'
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import Axios from './classes/Axios.js';
import autocomplete from './components/autocomplete.vue';
import modalDynamic from './components/modal-dynamic.vue';
import TimecardMixin from './mixins/TimecardMixin';
import UtilitiesMixin from './mixins/UtilitiesMixin';
import calendar from './components/calendar.vue';
import DateField from './components/DateField.vue';
import oasisModal from './components/oasis-modal.vue';
import AgGrid from './components/AgGrid.vue';
import DateFormatUtil from './mixins/DateFormatUtil.js';
require('./classes/PrototypeExt.js');

var app = createApp({

    components: {
        calendar,
        DateField,
        autocomplete,
        'modal-dynamic': modalDynamic,
        'oasis-modal': oasisModal,
        AgGrid,
    },

    mixins: [TimecardMixin, UtilitiesMixin, DateFormatUtil],

    data() {
        return {
            localValueFormatter: function localValueFormatter(params) {
                var value = params.value;
                if (!value) return 'Non Union';
                return value;
            },
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            waiting: false, // whole-page spinner
            loading: false, // spinner
            adminAccess: false,
            proPayPayrollId: null,
            showTimecardDetail: false,
            terminationModal: false,
            batchModal: false,
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],
            oasisApi: new Axios('/restv2'),
            oasisApiProd: new Axios('https://www.revolutiones.com/oasis/restv2'),
            propayFrontend: '',
            format: 'MM/dd/yyyy',

            tcSortMethodToApprove: '',
            tcSortMethodOpen: '',
            tcSortMethodApproved: '',
            tcSortMethodSearch: '',

            // employees/locations retrieved from database
            employees: [],
            timecards: undefined,
            timecardsOpen: undefined,
            timecardsMissing: undefined,
            timecardsApproved: undefined,
            timecardsSearch: [],
            timecardsSearchMap: {},
            departments: [],
            entity: undefined,
            entityId: entityId,
            batches: [],
            move_batch: {
                id: undefined, // When we move a batch
                name: undefined, // When we move a batch
            },
            showBatches: false,
            showEdits: false,
            hideMissingTimecards: false,
            weekEnding: '',

            statusFilterToApprove: '',
            statusesToApprove: [],
            batchesFilterToApprove: '',
            batchesToApprove: [],
            showFilterToApprove: '',
            showsToApprove: [],
            departmentFilterToApprove: '',
            departmentsToApprove: [],
            accountFilterToApprove: '',
            accountsToApprove: [],
            weekFilterToApprove: '',
            weekEndingsToApprove: [],
            unionFilterToApprove: '',
            unionsToApprove: [],

            statusFilterNew: '',
            statusesNew: [],
            batchesFilterNew: '',
            batchesNew: [],
            showFilterNew: '',
            showsNew: [],
            departmentFilterNew: '',
            departmentsNew: [],
            accountFilterNew: '',
            accountsNew: [],
            weekFilterNew: '',
            weekEndingsNew: [],
            unionFilterNew: '',
            unionsNew: [],

            statusFilterApproved: '',
            statusesApproved: [],
            batchesFilterApproved: '',
            batchesApproved: [],
            showFilterApproved: '',
            showsApproved: [],
            departmentFilterApproved: '',
            departmentsApproved: [],
            accountFilterApproved: '',
            accountsApproved: [],
            weekFilterApproved: '',
            weekEndingsApproved: [],
            unionFilterApproved: '',
            unionsApproved: [],

            batchesFilterSearch: '',
            batchesSearch: [],
            employeeFilterSearch: '',
            employeesSearch: [],
            showFilterSearch: '',
            showsSearch: [],
            departmentFilterSearch: '',
            departmentsSearch: [],

            weekFilterSearch: '',
            weekEndingsSearch: [],
            unionFilterSearch: '',
            unionsSearch: [],

            // Checkbox details for timecards
            selectedTimecards: [],
            selectedOpenTimecards: [],
            selectedApprovedTimecards: [],
            selectedMissingTimecards: [],

            // Starts
            allStarts: [],
            waitingStarts: undefined,
            unsentStarts: undefined,
            readyToApproveStarts: undefined,
            completedStarts: [],
            recentlyCompletedStarts: [],
            needingI9Starts: undefined,
            terminatedStarts: [],
            openStarts: undefined,

            certifiedEmployees: [],
            certifiedStatus: false,
            certifiedSupervisor: undefined,

            sortMethodStarts: '',
            statusFilterStarts: '',
            statusesStarts: [],
            batchesFilterStarts: '',
            batchesStarts: [],
            departmentFilterStarts: '',
            departmentsStarts: [],
            unionLocalFilterStarts: '',
            unionLocalStarts: [],

            // Checkbox details for starts
            selectedWaitingStarts: [],
            selectedUnsentStarts: [],
            selectedReadyToApproveStarts: [],
            selectedCompletedStarts: [],
            selectedRecentlyCompletedStarts: [],
            selectedNeedingI9Starts: [],
            selectedTerminatedStarts: [],
            selectedAllStarts: [],
            selectedOpenStarts: [],
            selectedCertifications: [],

            // Edits
            edits: [],
            selectedEdits: [],

            reportServer: 'https://jasper.revolutiones.com:8443/jasperserver/rest_v2/reports/Revolution/Phoenix/',
            showJson: false,
            jsonOverride: {},
            termDate: '',
            terminationMessage: '',
            termFormsAvailable: [],
            termForms: [],
            termFormFields: {},
            selectedTermForms: [],
            harassmentCertification: undefined,

            // New Ag-Grid Search
            selectedAssignment: '',
            searchQueryBatch: '',
            searchQueryUnion: '',
            searchQueryDept: '',
            searchQueryEmployee: '',
            searchQueryAssignment: '',
            searchQueryDateStart: '',
            searchQueryDateEnd: '',
            pageCurrent: 1,
            pagesTotal: 1,

            // Ag-Grid
            iteration: 0,
            columnDefs: undefined,
            sidebar: undefined,
            filterOrder: undefined,
            timecardHistoryRowData: [],
            gridOptions: {
                singleClickEdit: false,
                undoRedoCellEditing: false,
                enterMovesDown: false,
                enterMovesDownAfterEdit: false,
                rowSelection: 'multiple',
                suppressContextMenu: true,
                enableRangeSelection: true,
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    menuTabs: [],
                    suppressSizeToFit: false,
                    headerCheckboxSelectionFilteredOnly: true,
                    floatingFilter: true,
                    filterParams: {
                        suppressMiniFilter: false,
                        defaultToNothingSelected: true,
                        buttons: ['reset', 'apply'],
                        debounceMs: 200
                    }
                },
                onGridReady: (event) => this.$refs['timecardHistory'].onGridReady(event),
                onFilterChanged: (event) => {
                    // Deselects previously selected data when the filter is changed.
                    this.$refs['timecardHistory'].gridApi.deselectAll();
                },
            },

            // New Batch
            newBatch: {
                name: '',
                description: '',
                status: 1,
            }
        }
    },

    computed: {
        disabled() {
            let days;
            let weekEndingDay;
            if (this.entity && this.entity.week_ending) weekEndingDay = this.entity.week_ending;
            
            switch (weekEndingDay) {
                case 'Sunday':
                    days = [1, 2, 3, 4, 5, 6];
                    break;

                case 'Monday':
                    days = [0, 2, 3, 4, 5, 6];
                    break;

                case 'Tuesday':
                    days = [0, 1, 3, 4, 5, 6];
                    break;

                case 'Wednesday':
                    days = [0, 1, 2, 4, 5, 6];
                    break;

                case 'Thursday':
                    days = [0, 1, 2, 3, 5, 6];
                    break;

                case 'Friday':
                    days = [0, 1, 2, 3, 4, 6];
                    break;

                default:
                    days = [0, 1, 2, 3, 4, 5];
            }

            return days;
        },
        width() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return '100%';
        },

        height() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return window.innerHeight * 0.63 + 'px';
        },

        searchTimecards() {
            return this.timecardHistoryRowData;
        },
    },

    methods: {
        pushArray(data, array, sort) {
            array.pushUnique(data, sort);
            return data;
        },

        buildCommentsLink(params) {
            return params.value ? `<a href="/oasis/timecard/create/${params.data.hash}" target="_blank" data-toggle="tooltip" data-placement="left" data-html="true" title="${params.value}">View</a>` : '';
        },

        processTimecards(selected) {
            if (!selected) selected = this.selectedTimecards;
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to process.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            this.createDialog({
                "title": "Please Confirm",
                "body": 'Mark these cards as "Payroll Processed."',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function () { app.changeApi('process', selected); }
            });

        },

        changeApi(type, selected) {
            if (!type || !selected) return false;
            if (typeof selected === 'function') selected = selected();

            let data = {};
            let apiEndpoint;
            let newStatus;
            let newStatusId;
            if (type === 'void') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/void';
                newStatus = 'Voided';
                newStatusId = 0;
            } else if (type === 'unfinalize') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/unfinalize';
                newStatus = 'Unfinalizing';
            } else if (type === 'returnToEmployer') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/returnToEmployer';
                newStatus = 'Returning to Employer';
            } else if (type === 'process') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/process';
                newStatus = 'Payroll Processed';
                newStatusId = 3;
            } else if (type === 'updateTimecardAssignment') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/refreshAssignment';
                newStatus = 'Refreshed';
            } else if (type === 'recalcTimecards') {
                data.timecards = selected;
                apiEndpoint = '/bulkchange/timecard/recalc';
                newStatus = 'Recalc\'d';
            } else if (type === 'changebatch') {
                data.timecards = selected;
                data.batch_id = this.move_batch.id;
                apiEndpoint = '/bulkchange/timecard/changebatch';
                newStatus = 'Batch Changed';
            } else if (type === 'terminateStart') {
                data.starts = selected;
                data.term_date = this.termDate;
                data.message = this.terminationMessage;
                data.termForms = this.selectedTermForms;
                data.termFormFields = this.termFormFields;
                apiEndpoint = '/bulkchange/start/terminate';
                newStatus = 'Terminated';
            } else {
                return false;
            }

            this.waiting = true;

            this.oasisApi.patch(apiEndpoint, data)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200) {
                        this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        if (response.data.ids && Array.isArray(response.data.ids)) {
                            for (let i = 0; i <= response.data.ids.length; i++) {
                                let hash = response.data.ids[i];
                                // Remove from toApprove list
                                if (this.timecards && hash) {
                                    let index = this.timecards.findIndex((el) => { return el.hash == hash });
                                    // console.log (index, hash);
                                    if (type !== 'changebatch') {
                                        this.timecards.splice(index, 1);
                                    }
                                }

                                // Change status
                                if (this.timecardHistoryRowData && hash) {
                                    let tcdata = this.timecardHistoryRowData.find((tc) => tc.hash === hash)
                                    if (tcdata && newStatus) tcdata.status_full = newStatus;
                                    if (tcdata && newStatusId) tcdata.status = newStatusId;
                                }
                            }
                        }

                    } else if (response.status == 400) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                })
                ;

        },

        // Probably good forMixins!
        async getBatches() {
            const response = await this.oasisApi.get('/batches')
            this.batches = (response.data || {}).count > 0 ? response.data.results : [];
            return this.batches;
        },

        today() {
            let date = new Date(),
                mm = date.getMonth() + 1,
                dd = date.getDate();

            return [date.getFullYear(),
            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd
            ].join('/');
        },

        getJson(json) {
            return new Promise((resolve, reject) => {
                let data = { json: json }
                this.oasisApiProd.post('/addJson', data)
                    .then(response => {
                        if (response.status === 200) {
                            return resolve(response.data);
                        } else {
                            return reject(response);
                        }
                    })
                    .catch(error => reject(error));
                ;
            });
        },

        getReport(url, type) {
            return new Promise((resolve, reject) => {
                let data = { url: url }
                this.oasisApiProd.post('/getReport/' + type, data)
                    .then(response => {
                        if (response.status === 200) {
                            return resolve(response.data);
                        } else {
                            return reject(response);
                        }
                    })
                    .catch(error => reject(error));
                ;
            });
        },

        getSpreadsheet(url) {
            return new Promise((resolve, reject) => {
                let data = { url: url }
                this.oasisApi.post('/getSpreadsheet', data)
                    .then(response => {
                        if (response.status === 200) {
                            return resolve(response.data);
                        } else {
                            return reject(response);
                        }
                    })
                    .catch(error => reject(error));
                ;
            });
        },

        exportTimecardsPropay(selected, useExistingPayroll = false) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            if (useExistingPayroll && this.proPayPayrollId && !isNaN(this.proPayPayrollId)) {
                data.payrollId = this.proPayPayrollId;
            }

            // console.log(data);
            this.loading = true;

            this.oasisApi.post('/export/timecardsPropay', data)
                .then(response => {
                    if (response.status == 200) {
                        const data = response.data.results.data
                        let message = '';
                        if (Array.isArray(data)) {
                            let total = 0;
                            let count = 0;
                            message += 'Timecards Exported. Please Click Below to check the payroll(s).<br />';
                            for (const i in data) {
                                if (!data[i] || !data[i].id) continue;
                                message += `<a target="_blank" href="${this.propayFrontend + data[i].id}">${data[i].number}</a><br/>`;
                                total += parseFloat(data[i].payLinesTotal || '0');
                                count += parseInt(data[i].assignmentCount || '0');
                            }
                            message += `# Timecards Exported: ${count}.  ProPay Gross Total: $${total}`;
                        } else {
                            message += 'Timecards Exported. Please <a target="_blank" href="' + this.propayFrontend + data.id + '">click here</a> to check the payroll.<br/>';
                            message += `# Timecards Exported: ${data.assignmentCount}.  ProPay Gross Total: $${data.payLinesTotal}`;
                        }
                        this.createDialog({
                            "title": "Success", "body": message,
                            "buttonYesLabel": "OK",
                            "buttonNoLabel": "Mark as Processed",
                            "buttonNoAction": function () { app.changeApi('process', selected); }
                        });

                    } else if (response.status == 400 || response.status == 422) {
                        if (response.data && response.data.results && response.data.results.errors) {
                            let errors = '';
                            if (typeof response.data.results.errors === 'string') {
                                errors = response.data.results.errors;
                            } else if (typeof response.data.results.errors === 'object') {
                                for (const i in (response.data.results.errors || [])) {
                                    const e = response.data.results.errors[i];
                                    errors += e.message ? e.message + '<br />' : '';
                                }
                            }
                            this.createDialog({ "title": "Error", "body": errors, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data && response.data.errors) {
                            let errors = '';
                            if (typeof response.data.errors === 'string') {
                                errors = response.data.errors;
                            } else if (typeof response.data.errors === 'object') {
                                for (const i in (response.data.errors || [])) {
                                    const e = response.data.errors[i];
                                    errors += e.message ? e.message + '<br />' : '';
                                }
                            }
                            this.createDialog({ "title": "Error", "body": errors, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data && response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.loading = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.loading = false;
                });
        },

        exportTimecards(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/export/timecards', data)
                .then(response => {
                    if (response.status == 200) {
                        this.downloadCsv(response.data.csv, response.data.name);
                        // this.createDialog({ "title": "Success", "body": 'Success', "buttonNo": false, "buttonYesLabel": "OK" });
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        exportPointZero(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/export/pointzero', data)
                .then(response => {
                    if (response.status == 200) {
                        this.downloadCsv(response.data.csv, response.data.name);
                        // this.createDialog({ "title": "Success", "body": 'Success', "buttonNo": false, "buttonYesLabel": "OK" });
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        exportHotBudget(selected) {
            if (!selected || (selected.length === 0 && typeof selected !== 'function')) {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to export', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            let data = {
                "hashes": selected
            };

            // console.log(data);
            this.waiting = true;

            this.oasisApi.post('/export/hotbudget', data)
                .then(response => {
                    if (response.status == 200) {
                        this.downloadCsv(response.data.csv, response.data.name);
                        // this.createDialog({ "title": "Success", "body": 'Success', "buttonNo": false, "buttonYesLabel": "OK" });
                    } else if (response.status == 400) {
                        if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert(error);
                    this.waiting = false;
                });
        },

        downloadCsv(csvData, name) {
            if (!csvData) return false
            const filename = (name || 'Timecard') + '.csv'

            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename)
            } else {
                let csvElement = document.createElement('a')
                var url = URL.createObjectURL(blob)
                csvElement.setAttribute('href', url)
                csvElement.setAttribute('download', filename)
                csvElement.setAttribute('target', '_blank')
                csvElement.style.visibility = 'hidden'
                document.body.appendChild(csvElement)
                csvElement.click()
                document.body.removeChild(csvElement)
            }
        },

        async exportExcel() {
            this.waiting = true;
            await this.$refs['timecardHistory'].exportToExcel();
            this.waiting = false;
        },

        selectedSearchTimecardData() {
            return this.getSelectedData('timecardHistory');
        },

        getSelectedData(gridRef) {
            if (!gridRef || !this.$refs[gridRef] || !this.$refs[gridRef].gridOptions) return [];
            return ((this.$refs[gridRef].gridOptions.api || {}).getSelectedRows() || []);
        },

        selectedSearchTimecards() {
            return this.getSelectedHashes('timecardHistory');
        },

        getSelectedHashes(gridRef) {
            if (!gridRef || !this.$refs[gridRef] || !this.$refs[gridRef].gridOptions) return [];
            return ((this.$refs[gridRef].gridOptions.api || {}).getSelectedRows() || []).map((row) => row.hash);
        },

        resetSearch() {
            const now = new Date();
            const today = now.toISOString().split('T')[0];
            const lastWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 31).toISOString().split('T')[0];
            if (typeof this.$refs['employee_search'] !== 'undefined') this.$refs['employee_search'].reset();
            if (this.$refs['timecardHistory']) this.$refs['timecardHistory'].reset();
            if (this.timecardHistoryRowData) this.timecardHistoryRowData = undefined;
            this.searchQueryBatch = this.searchQueryUnion = this.searchQueryEmployee = this.searchQueryAssignment = this.searchQueryDept = undefined;
            this.searchQueryDateStart = '';
            this.searchQueryDateEnd = '';
        },

        // Get query results and put into rowdata for ag-grid
        async getQueryResults(rowData = 'timecardHistoryRowData') {
            this.loading = true;
            this[rowData] = undefined;
            let query = {
                entity_id: this.entityId,
            };

            if (this.searchQueryBatch) query.batch_id = this.searchQueryBatch;
            if (this.searchQueryUnion) query.union_id__gt = this.searchQueryUnion;
            if (this.searchQueryAssignment) query.assignment_id = this.searchQueryAssignment;
            if (this.searchQueryEmployee) query.search = this.searchQueryEmployee;
            if (this.searchQueryDateStart && this.searchQueryDateStart != 'Invalid DateTime') query.week_ending__ge = new Date(this.searchQueryDateStart).toISOString().split('T')[0];
            if (this.searchQueryDateEnd && this.searchQueryDateEnd != 'Invalid DateTime') query.week_ending__le = new Date(this.searchQueryDateEnd).toISOString().split('T')[0];

            let queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&');
            const timecardResponse = await this.oasisApi.getAllPages('/timecardHistory?' + queryString);
            // console.log(query, queryString, timecardResponse);
            this[rowData] = timecardResponse.data.results;
            this.iteration++;
            this.loading = false;
        },

        updateQuery(type, target) {
            this[type] = target && target.id ? target.id : target;
        },

        updateCalendar(target, value) {
            this.$data[target] = value;
        },

        async calcProPay(payrollId, selected) {
            if (!payrollId) return false;
            this.loading = true;
            const response = await this.oasisApi.get('/calcPayroll/' + payrollId);
            await this.changeApi('process', selected);
            this.loading = false;
        },

        // Generic test function
        log(value) {
            console.log('Logging:');
            console.log(value);
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) {
                this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () { }; }

            if (options.buttonYesLabel) {
                this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) {
                this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () { }; }

            if (options.buttonNoLabel) {
                this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) {
                this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () { }; }

            if (options.button3Label) {
                this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },

        createLink(value) {
            return value;
        },

        openWindow(link = '', target = '') {
            // console.log(link)
            let child = window.open(link, target);
            child.onunload = () => {
                this.loadDashboardData();
            };
        },

        recalcTimecards(selected) {
            if (!selected) selected = this.selectedTimecards;
            if (selected.length === 0 && typeof selected !== 'function') {
                this.createDialog({ "title": "Error", "body": 'Please select at least one timecard to recalc.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            if (typeof selected === 'function') selected = selected();

            this.createDialog({
                "title": "Please Confirm",
                "body": 'This will re-calculate selected Timecards.',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function () { app.changeApi('recalcTimecards', selected); }
            });
        },
    },

    watch: {
    },

    async created() {
        this.format = this.getDateFormat();
        this.propayFrontend = (typeof frontendUrl !== 'undefined' && frontendUrl) ? frontendUrl : 'https://propay.revolutiones.org/payrolls/';

        await this.oasisApi.get('/entities')
            .then(response => {
                this.entity = response.data;
                if (response.data.hasOwnProperty('other_properties') && response.data.other_properties) {
                    const data = this.isJson(response.data.other_properties) ? JSON.parse(response.data.other_properties) : response.data.other_properties;
                    this.showBatches = data.showBatches || false;
                    this.hideMissingTimecards = data.hideMissingTimecards || false;
                    this.getBatches();
                    return response.data
                }
            })
            .then(results => {
                if (this.harassmentCertification) {
                    this.oasisApi.get('/employeeCertifications/' + this.entity.id)
                        .then(response => {
                            // console.log(response.data.results);
                            this.certifiedEmployees = response.data.results;
                        })
                        .catch(error => { console.log(error); }
                        );
                }
            })
            .catch(error => { console.log(error); }
            );

        const tcFilterOrder = [
            { field: 'status_full' },
            { field: 'week_ending' },
            { field: 'employee' },
            { field: 'job_title_override' },
            { field: 'department' },
            { field: 'union_local' },
            { field: 'budget_code' },
            { field: 'fringe_code' },
            { field: 'series_code' },
            { field: 'location_code' },
            { field: 'set_code' },
            { field: 'free_field' },
            { field: 'free_field2' },
        ];

        const tcHistoryColumnDefs = [
            {
                headerName: 'Batch',
                field: 'batch',
                colId: 'batch',
                maxWidth: 300,
                width: 100,
                editable: false,
                sortable: true,
                filter: true,
                hide: !this.showBatches,
                valueGetter: (params) => params.data.batch ? params.data.batch : '',
                menuTabs: [],
            },
            {
                headerName: 'PR ID',
                field: 'propay_id',
                colId: 'propay_id',
                maxWidth: 120,
                width: 80,
                editable: false,
                sortable: true,
                filter: true,
                hide: !adminAccess,
                valueGetter: (params) => params.data.propay_id ? parseInt(params.data.propay_id) : '',
                cellRenderer: (params) => params.data.propay_id ? `<a href="${this.propayFrontend}${params.data.propay_id}" target="_blank">${params.data.propay_id}</a>` : '',
                menuTabs: [],
            },
            {
                headerName: 'Show/Job',
                field: 'entity',
                colId: 'entity',
                maxWidth: 200,
                width: 100,
                hide: true,
                editable: false,
                sortable: true,
                filter: true,
                menuTabs: [],
            },
            {
                headerName: 'Status',
                field: 'status_full',
                colId: 'status_full',
                maxWidth: 250,
                width: 170,
                editable: false,
                sortable: true,
                filter: true,
                checkboxSelection: true,
                headerCheckboxSelection: true,
                menuTabs: [],
            },
            {
                headerName: 'Week Ending',
                field: 'week_ending',
                colId: 'week_ending',
                maxWidth: 120,
                width: 110,
                editable: false,
                sortable: true,
                filter: true,
                cellRenderer: (params) => `<a href="/oasis/timecard/create/${params.data.hash}" target="_blank">${params.data.week_ending.substring(0, 10)}</a>`,
                filterParams: {
                    valueFormatter: (params) => params.value.substring(0, 10)
                },
                menuTabs: [],
            },
            {
                headerName: 'Employee',
                field: 'employee',
                colId: 'employee',
                maxWidth: 200,
                minWidth: 80,
                editable: false,
                sortable: true,
                filter: true,
                cellRenderer: (params) => `<a href="/oasis/timecard/create/${params.data.hash}" target="_blank">${params.data.employee}</a>`,
                menuTabs: [],
            },
            {
                headerName: 'Title',
                field: 'assignment_object.job_title_override',
                colId: 'job_title_override',
                maxWidth: 300,
                minWidth: 70,
                editable: false,
                sortable: true,
                filter: true,
                menuTabs: [],
            },
            {
                headerName: 'Local',
                field: 'union_local',
                colId: 'union_local',
                maxWidth: 120,
                minWidth: 50,
                editable: false,
                sortable: true,
                filter: true,
                filterParams: { valueFormatter: this.localValueFormatter },
                menuTabs: [],
            },
            {
                headerName: 'Dept',
                field: 'department',
                colId: 'department',
                maxWidth: 180,
                minWidth: 60,
                editable: false,
                sortable: true,
                filter: true,
                menuTabs: [],
            },
            {
                headerName: 'Base Rate',
                field: 'assignment_object.rate',
                colId: 'rate',
                maxWidth: 120,
                minWidth: 40,
                cellClass: 't-right',
                editable: false,
                sortable: true,
                filter: 'agNumberColumnFilter',
                valueGetter: (params) => parseFloat(params.data.assignment_object.rate || 0),
                valueFormatter: (params) => params.value.formatNumber(),
                menuTabs: [],
            },
            {
                headerName: 'Unit',
                field: 'assignment_object.rate_unit',
                colId: 'rate_unit',
                maxWidth: 80,
                width: 60,
                editable: false,
                sortable: true,
                filter: true,
                menuTabs: [],
            },
            {
                headerName: 'Gross Pay',
                colId: 'gross',
                maxWidth: 200,
                minWidth: 100,
                width: 110,
                cellClass: 't-right bold',
                editable: false,
                sortable: true,
                filter: 'agNumberColumnFilter',
                valueGetter: (params) => parseFloat(params.data.total_pay || 0),
                valueFormatter: (params) => params.value.formatNumber(),
                menuTabs: [],
            },
            {
                headerName: 'Hours',
                colId: 'total_hours',
                maxWidth: 100,
                width: 70,
                cellClass: 't-right bold',
                editable: false,
                sortable: true,
                filter: 'agNumberColumnFilter',
                valueGetter: (params) => parseFloat(params.data.total_hours || 0),
                valueFormatter: (params) => params.value.formatNumber(),
                menuTabs: [],
            },
            {
                headerName: 'OT',
                colId: 'total_ot',
                maxWidth: 100,
                width: 70,
                cellClass: 't-right',
                editable: false,
                sortable: true,
                filter: 'agNumberColumnFilter',
                valueGetter: (params) => (params.data.total_ot && parseInt(params.data.assignment_object.flsa_type_id) !== 2) ? (parseFloat(params.data.total_hours) - parseFloat(((((params.data.broken_object || {}).week || {}).pay_straight || {}).hours) || 0) - parseFloat(((((params.data.broken_object2 || {}).week || {}).pay_straight || {}).hours) || 0)) : 0,
                valueFormatter: (params) => params.value.formatNumber(),
                menuTabs: [],
            },
            {
                headerName: 'Exp',
                colId: 'guarantee',
                maxWidth: 100,
                width: 65,
                cellClass: 't-right',
                editable: false,
                sortable: true,
                filter: 'agNumberColumnFilter',
                hide: this.true,
                valueGetter: (params) => {
                    const daysWorked = parseFloat(params.data.broken_object.week.daysWorked || 0) 
                    const guaranteedHours = parseFloat(params.data.assignment_object.guaranteed_hours || 8)
                    const guaranteedWeeklyHours = parseInt(params.data.assignment_object.guaranteed_hours_unit_id) === 8 ? (daysWorked * guaranteedHours) : guaranteedHours
                    return guaranteedWeeklyHours
                },
                menuTabs: [],
            },
            {
                headerName: '> Exp',
                colId: 'overGuarantee',
                maxWidth: 100,
                width: 70,
                cellClass: (params) => params.value > 0 ? 'form-error t-right' : 't-right',
                editable: false,
                sortable: true,
                filter: 'agNumberColumnFilter',
                valueGetter: (params) => {
                    // Always show 0 for exempt
                    if (parseInt(params.data.assignment_object.flsa_type_id) === 2) {
                        return 0
                    }
                    const totalHours = parseFloat(params.data.total_hours) 
                    const daysWorked = parseFloat((((params.data.broken_object || {}).week || {}).daysWorked) || 0) + parseFloat((((params.data.broken_object2 || {}).week || {}).daysWorked) || 0)
                    const guaranteedHours = parseFloat(params.data.assignment_object.guaranteed_hours || 8)
                    const guaranteedWeeklyHours = parseInt(params.data.assignment_object.guaranteed_hours_unit_id) === 8 ? (daysWorked * guaranteedHours) : guaranteedHours
                    if (totalHours - guaranteedWeeklyHours > 0) {
                        return (totalHours - guaranteedWeeklyHours)
                    } else {
                        return 0;
                    }
                },
                valueFormatter: (params) => params.value.formatNumber(),
                menuTabs: [],
            },
            {
                headerName: 'Allowances',
                colId: 'allowances',
                maxWidth: 180,
                width: 100,
                cellClass: 't-right',
                editable: false,
                sortable: true,
                filter: 'agNumberColumnFilter',
                valueGetter: (params) => parseFloat(((((params.data.broken_object || {}).week || {}).allowances || {}).pay) || 0),
                valueFormatter: (params) => params.value.formatNumber(),
                menuTabs: [],
            },
            {
                headerName: 'Penalties',
                colId: 'penalties',
                maxWidth: 100,
                width: 80,
                cellClass: (params) => parseFloat(params.value) > 0 ? 't-right form-error' : 't-right',
                editable: false,
                sortable: true,
                filter: 'agNumberColumnFilter',
                valueGetter: (params) => parseFloat(((((params.data.broken_object || {}).week || {}).penalties || {}).pay) || 0) + parseFloat(((((params.data.broken_object2 || {}).week || {}).penalties || {}).pay) || 0),
                valueFormatter: (params) => params.value.formatNumber(),
                menuTabs: [],
            },
            {
                headerName: 'Days',
                colId: 'daysWorked',
                maxWidth: 100,
                width: 60,
                cellClass: 't-right',
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => parseFloat((((params.data.broken_object || {}).week || {}).daysWorked) || 0) + parseFloat((((params.data.broken_object2 || {}).week || {}).daysWorked) || 0),
                menuTabs: [],
            },
            {
                headerName: 'Comments',
                field: 'comments',
                colId: 'comments',
                maxWidth: 100,
                width: 90,
                editable: false,
                sortable: true,
                cellRenderer: (params) => this.buildCommentsLink(params),
                valueGetter: (params) => {
                    let ee = '',
                        er = '';

                    if (params.data.employee_comments) ee = "Main:" + params.data.employee_comments + "\n";
                    if (params.data.employer_comments) er = "Main:" + params.data.employer_comments + "\n";

                    for (let i in params.data.timecard_object) {
                        if (!params.data.timecard_object[i] || typeof params.data.timecard_object[i] !== 'object') continue;
                        if (params.data.timecard_object[i].hasOwnProperty('employee_comments')) {
                            ee += params.data.timecard_object[i].date.short + ": " + params.data.timecard_object[i].employee_comments + "\n";
                        }
                        if (params.data.timecard_object[i].hasOwnProperty('employer_comments')) {
                            er += params.data.timecard_object[i].date.short + ": " + params.data.timecard_object[i].employer_comments + "\n";
                        }
                    }

                    if (ee || er) {
                        ee = ee ? 'EMPLOYEE COMMENTS:\n' + ee.replace(/\"/g, "") + '\n\n' : '';
                        er = er ? 'EMPLOYER COMMENTS:\n' + er.replace(/\"/g, "") : '';
                        return `${ee}${er}`;
                    } else {
                        return '';
                    }
                },
                menuTabs: [],
            },
            {
                headerName: 'Account',
                field: 'assignment_object.budget_code',
                colId: 'budget_code',
                maxWidth: 100,
                minWidth: 60,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                   if (!params.data.assignment_object.budget_code) return '';
                   else return params.data.assignment_object.budget_code;
                },
                menuTabs: [],
            },
            {
                headerName: 'Fringe',
                field: 'assignment_object.fringe_code',
                colId: 'fringe_code',
                maxWidth: 100,
                minWidth: 60,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.assignment_object.fringe_code) return '';
                    else return params.data.assignment_object.fringe_code;
                 },
                menuTabs: [],
            },
            {
                headerName: 'Series',
                field: 'assignment_object.series_code',
                colId: 'series_code',
                maxWidth: 100,
                minWidth: 60,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.assignment_object.series_code) return '';
                    else return params.data.assignment_object.series_code;
                 },
                menuTabs: [],
            },
            {
                headerName: 'Location',
                field: 'assignment_object.location_code',
                colId: 'location_code',
                maxWidth: 100,
                minWidth: 60,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.assignment_object.location_code) return '';
                    else return params.data.assignment_object.location_code;
                 },
                menuTabs: [],
            },
            {
                headerName: 'Set',
                field: 'assignment_object.set_code',
                colId: 'set_code',
                maxWidth: 100,
                minWidth: 60,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.assignment_object.set_code) return '';
                    else return params.data.assignment_object.set_code;
                 },
                menuTabs: [],
            },
            {
                headerName: 'FF1',
                field: 'assignment_object.free_field',
                colId: 'free_field',
                maxWidth: 100,
                minWidth: 60,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.assignment_object.free_field) return '';
                    else return params.data.assignment_object.free_field;
                 },
                menuTabs: [],
            },
            {
                headerName: 'FF2',
                field: 'assignment_object.free_field2',
                colId: 'free_field2',
                maxWidth: 100,
                minWidth: 60,
                editable: false,
                sortable: true,
                filter: true,
                valueGetter: (params) => {
                    if (!params.data.assignment_object.free_field2) return '';
                    else return params.data.assignment_object.free_field2;
                 },
                menuTabs: [],
            },
            {
                headerName: 'TC ID',
                field: 'id',
                colId: 'id',
                maxWidth: 120,
                width: 80,
                editable: false,
                sortable: true,
                filter: true,
                hide: !adminAccess,
                cellRenderer: (params) => `<a href="/oasis/timecard/create/${params.data.hash}" target="_blank">${params.data.id}</a>`,
                menuTabs: [],
            },
            {
                headerName: 'Assignment ID',
                field: 'assignment_id',
                colId: 'assignment_id',
                maxWidth: 120,
                width: 80,
                editable: false,
                sortable: true,
                filter: true,
                hide: !adminAccess,
                menuTabs: [],
            },
        ];

        this.columnDefs = tcHistoryColumnDefs;
        this.filterOrder = tcFilterOrder;
    },

    beforeCreate() {
        this.oasisApi = new Axios('/restv2');
    },

    async mounted() {
        setTimeout(() => { $('[data-toggle="tooltip"]').tooltip() }, 500);
        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };
        this.adminAccess = typeof adminAccess !== 'undefined' ? (adminAccess ? true : false) : false;

        this.resetSearch();
        this.getQueryResults('timecardHistoryRowData');
    }
}).mount("#dashboard");
